import { css } from "styled-system/css";
import { motion, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

export function DashboardPageShell({
  eyebrow = "Panel",
  title,
  description,
  actions,
  children,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const shouldReduceMotion = useReducedMotion();

  return (
    <motion.div
      className={css({ display: "flex", flexDir: "column", gap: "6" })}
      initial={shouldReduceMotion ? false : { opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.23, 1, 0.32, 1] }}
    >
      <div
        className={css({
          display: "flex",
          flexDir: { base: "column", sm: "row" },
          justifyContent: "space-between",
          gap: "4",
          alignItems: { sm: "flex-start" },
        })}
      >
        <div>
          <p className={css({ fontSize: "xs", letterSpacing: "widest", color: "#64748b", mb: "2" })}>
            {eyebrow}
          </p>
          <h1 className={css({ fontSize: { base: "xl", md: "2xl" }, fontWeight: "bold", color: "#0f172a", letterSpacing: "tight" })}>
            {title}
          </h1>
          {description ? (
            <p
              className={css({
                fontSize: "sm",
                color: "#64748b",
                mt: "2",
                maxW: "42rem",
                lineHeight: "1.6",
              })}
            >
              {description}
            </p>
          ) : null}
        </div>
        {actions ? <div className={css({ flexShrink: 0 })}>{actions}</div> : null}
      </div>
      {children}
    </motion.div>
  );
}
